import { PageHeader } from '@/app/layouts/PageHeader'
import { Button } from '@/components/ui/Button'
import { EmptyState } from '@/components/ui/EmptyState'
import { PostListSkeleton } from '@/components/ui/Skeleton'
import { CenteredSpinner } from '@/components/ui/Spinner'
import { UserListItem, useFollowRequests, useRespondFollowRequest } from '@/features/profile'
import { useInfiniteScroll } from '@/hooks/useInfiniteScroll'
import { useT } from '@/i18n'

/** 我收到的关注请求（D76）。批准就成了关注者，拒绝对方不会收到任何提示。 */
export function FollowRequestsPage() {
  const t = useT()
  const query = useFollowRequests()
  const respond = useRespondFollowRequest()
  const sentinelRef = useInfiniteScroll({
    hasNextPage: Boolean(query.hasNextPage),
    isFetchingNextPage: query.isFetchingNextPage,
    fetchNextPage: query.fetchNextPage,
  })
  const users = query.data?.pages.flatMap((page) => page.items) ?? []

  return (
    <>
      <PageHeader title={t('followRequests.title')} back />
      {query.isPending && <PostListSkeleton count={3} />}
      {!query.isPending && users.length === 0 && (
        <EmptyState title={t('followRequests.empty')} description={t('followRequests.emptyBody')} />
      )}
      {users.map((user) => (
        <UserListItem
          key={user.id}
          user={user}
          actions={
            // 整行是个链接：按钮上的点击不能冒上去跳到对方主页
            <div className="flex gap-2">
              <Button
                size="sm"
                disabled={respond.isPending}
                onClick={(event) => {
                  // 按钮在整行的 <a> 里：只拦冒泡不够，浏览器照样会跟着链接走
                  event.preventDefault()
                  event.stopPropagation()
                  respond.mutate({ username: user.username, approve: true })
                }}
              >
                {t('followRequests.approve')}
              </Button>
              <Button
                size="sm"
                variant="outline"
                disabled={respond.isPending}
                onClick={(event) => {
                  event.preventDefault()
                  event.stopPropagation()
                  respond.mutate({ username: user.username, approve: false })
                }}
              >
                {t('followRequests.reject')}
              </Button>
            </div>
          }
        />
      ))}
      <div ref={sentinelRef} aria-hidden className="h-px" />
      {query.isFetchingNextPage && <CenteredSpinner />}
    </>
  )
}
